'use client';

import { FC } from 'react';

import { useBonanzaPromo } from '../../hooks';
import { ImageComponent } from '@/components/Image';
import {
  ProgressBar,
  ValuePosition,
} from '@/components/progressBars/LinearProgressBar';
import { useCommonStore } from '@/store/commonStore';

import { ScBonanzaPromoDashboardContent } from './styled';
import { ProgressBarMode } from '@/components/progressBars/LinearProgressBar/styled';

interface BonanzaPromoDashboardContentProps {
  onClick?: () => void;
}

export const BonanzaPromoDashboardContent: FC<
  BonanzaPromoDashboardContentProps
> = ({ onClick }) => {
  const bonanzaProgressPercent = useCommonStore.use.bonanzaProgressPercent();
  const { isLockedPromo, isBonusIssued, characterByStatus } = useBonanzaPromo();

  return (
    <ScBonanzaPromoDashboardContent
      onClick={onClick}
      isLockedPromo={isLockedPromo}
    >
      {!isLockedPromo && (
        <ProgressBar
          value={bonanzaProgressPercent}
          mode={
            isBonusIssued
              ? ProgressBarMode.GREEN_WHITE
              : ProgressBarMode.PRIMARY_GRAY
          }
          showValue={ValuePosition.CENTER}
          height={20}
          borderRadius="20px"
          borderRadiusInner={isBonusIssued ? '20px' : '20px 0 0 20px'}
          withUnits
          showTo={false}
          minProgress={10}
        />
      )}
      {characterByStatus && (
        <ImageComponent
          height={32}
          width={32}
          src={characterByStatus?.image?.url}
          alt="character"
          className={isLockedPromo ? 'characterLocked' : 'character'}
        />
      )}
    </ScBonanzaPromoDashboardContent>
  );
};
